import { render, staticRenderFns } from "./employee-vocation.vue?vue&type=template&id=21972268"
import script from "./employee-vocation.vue?vue&type=script&lang=js"
export * from "./employee-vocation.vue?vue&type=script&lang=js"
import style0 from "./employee-vocation.vue?vue&type=style&index=0&id=21972268&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports